export type WhisperTooltip = {
  title: string;
  value: string | number;
  style?: React.CSSProperties;
  valueStyle?: React.CSSProperties;
};

export const formatWhisperTooltip = (tooltipData: WhisperTooltip[]) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      {tooltipData.map((item, index) => {
        return (
          <div
            key={index}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: item.value !== '' && item.title !== '' ? '10px' : '0',
              ...(item.style || {}),
            }}
          >
            {item.value !== '' ? (
              <>
                <div style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>{item.title}</div>
                <b style={{ flexShrink: 0, ...(item.valueStyle || {}) }}>{item.value}</b>
              </>
            ) : (
              <div>{item.title}</div>
            )}
          </div>
        );
      })}
    </div>
  );
};
